module.exports = __webpack_public_path__ + "img/img2.abf6f863.jpg";